(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amanita-product-funnel"] && !Shopify.designMode) return;
  try {
    
function initAmanitaProduct(scope) {
  const productRoots = scope.matches?.('[data-am-product]') ? [scope] : scope.querySelectorAll('[data-am-product]');
  productRoots.forEach((root) => {
    if (root.dataset.amReady) return;
    root.dataset.amReady = 'true';
    const variantForm = root.querySelector('[data-am-variant-form]');
    if (variantForm) {
      const submit = variantForm.querySelector('[data-am-variant-submit]');
      submit.hidden = true;
      variantForm.querySelector('[data-am-variant]').addEventListener('change', () => variantForm.requestSubmit());
    }
    root.querySelectorAll('[data-am-thumbnail]').forEach((thumbnail) => {
      thumbnail.addEventListener('click', (event) => {
        const mainImage = root.querySelector('.am-gallery__main img');
        if (!mainImage) return;
        event.preventDefault();
        mainImage.removeAttribute('srcset');
        mainImage.src = thumbnail.dataset.amImage;
        mainImage.alt = thumbnail.dataset.amAlt;
        root.querySelectorAll('[data-am-thumbnail]').forEach((item) => item.removeAttribute('aria-current'));
        thumbnail.setAttribute('aria-current', 'true');
      });
    });
    const plans = root.querySelector('[data-am-plan]');
    if (plans) plans.addEventListener('change', () => {
      const selection = plans.selectedOptions[0];
      root.querySelector('[data-am-price]').textContent = selection.dataset.price;
      const comparison = root.querySelector('[data-am-compare]');
      comparison.textContent = selection.dataset.compare;
      comparison.hidden = !selection.dataset.compare;
      root.querySelectorAll('[data-am-plan-description]').forEach((description) => {
        description.hidden = description.dataset.amPlanDescription !== plans.value;
      });
    });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAmanitaProduct(document));
else initAmanitaProduct(document);
document.addEventListener('shopify:section:load', (event) => initAmanitaProduct(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
